<template>
    <div v-if="loaded" class="flex w-full gap-5 h-full owners-view justify-content-around align-items-center flex-column overflow-hidden">
        <div class="section-table w-full">
            <div class="flex justify-content-between align-items-center flex-wrap">
                <h2 class="page-header">{{ $t('message.owner.header') }}</h2>
                <CustomButton :label="$t('message.owner.addNewButton')" @click="addNewOwner" />
            </div>
            <OwnerTable ref="ownerTable" v-model="selectedOwner" @showForm="showForm"
                        :countries="countries" />
        </div>
        <LibyanOrnament horizontal/>
        <div id="scrollToForm" class="section-details w-full">
            <h2 class="page-header">{{ createMode ? $t('message.owner.headerNew') : $t('message.owner.headerEdit') }}</h2>
            <OwnerForm :selectedOwner="selectedOwner" @change-element="reloadTable"
                       @createMode="(val) => createMode = val" @hideForm="hideForm"
                       :countries="countries" />
        </div>
    </div>
</template>

<script>
    import OwnerTable from "./components/OwnerTable";
    import OwnerForm from "./components/OwnerForm.vue";
    import LibyanOrnament from "@/components/LibyanOrnament.vue";
    import CustomButton from "@/components/form/CustomButton.vue";
    import { ScrollToUtils } from "@/utils/ScrollToUtils";
    import { ShowHideFormUtils } from "@/utils/ShowHideFormUtils";
    import {
        getCountries,
    } from "@/swagger/vue-api-client";

    export default {
        name: "OwnerListView",
        components: {
            OwnerTable,
            OwnerForm,
            LibyanOrnament,
            CustomButton,
        },

        data() {
            return {
                selectedOwner: {},
                createMode: true,
                countries: null,
                loaded: false,
            };
        },

        beforeMount() {
            getCountries()
                .then((response) => {
                    this.countries = response.data;
                    this.loaded = true;
                });
        },

        mounted() {
            this.selectedOwner = this.getClearOwner();
        },

        methods: {
            getClearOwner() {
                return {
                    suffix: null,
                    fullName: null,
                    business: false,
                    businessNumber: null,
                    nationalIdNumber: null,
                    phone: null,
                    address: {
                        street: null,
                        postalCode: null,
                        city: null,
                        region: null,
                        countryId: 1,
                        propertyNumber: null,
                        apartmentNumber: null,
                    },
                    owner: false,
                    breeder: false,
                    notes: null,
                };
            },
            reloadTable() {
                this.$refs.ownerTable.reloadTable();
                this.selectedOwner = this.getClearOwner();
            },
            addNewOwner() {
                this.showForm();
                this.$refs.ownerTable.addNewOwner();
                this.selectedOwner = this.getClearOwner();
                ScrollToUtils.scrollToElement(true);
            },
            showForm() {
                ShowHideFormUtils.showHideHorizontal(".section-details");
            },
            hideForm() {
                ShowHideFormUtils.showHideHorizontal(".section-details", true);
            },
        },
    };
</script>

<style scoped lang="scss">
    .owners-view {
        .section-table {
            min-height: calc(100vh - 230px);
        }
        .section-details {
            height: 0;
            &.showForm {
                height: 100%;
            }
        }
    }
</style>
